var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_5005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8 1.6H3.4V0H1.8V14.4H1V16H4.2V14.4H3.4V10.4H13.8C14.0122 10.4 14.2157 10.3157 14.3657 10.1657C14.5157 10.0157 14.6 9.81217 14.6 9.6V2.4C14.6 2.18783 14.5157 1.98434 14.3657 1.83431C14.2157 1.68429 14.0122 1.6 13.8 1.6Z",
    fill: "white",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_5005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.f35968b347385211eed39644e78c3536.svg";
export { ForwardRef as ReactComponent };